import { createLogger, type ILogger } from '@glomopay/telemetry/logger';

import { OTEL_ENABLED, SERVICE_NAME } from '@/constants/telemetry';

export const logger: ILogger = createLogger({
  serviceName: SERVICE_NAME,
  isOpenTelemetryEnabled: OTEL_ENABLED,
});

export type { ILogger, LogAttributes } from '@glomopay/telemetry/logger';
export { LogLevel } from '@glomopay/telemetry/logger';
